export function parseContents(data) {
    const { content, contentChallenge } = data.contents;
    const contents = {};
    if (content) {
        const contentArray = Array.isArray(content) ? content : [content];
        const contentArrayResponse = contentArray.map((contentPart) => {
            return {
                contentToken: contentPart.contentToken.$,
                checksum: contentPart.checksum.$,
                size: contentPart.size.$,
                chunk: contentPart.chunk.$,
            };
        });
        contents.content = contentArrayResponse;
    }
    if (contentChallenge) {
        const contentChallengeArray = Array.isArray(contentChallenge)
            ? contentChallenge
            : [contentChallenge];
        const contentChallengeArrayResponse = contentChallengeArray.map((contentChallengePart) => {
            return {
                offset: contentChallengePart['@offset'],
                length: contentChallengePart['@length'],
                checksum: contentChallengePart['@checksum'],
                token: contentChallengePart['@token'],
            };
        });
        contents.contentChallenge = contentChallengeArrayResponse;
    }
    return contents;
}
